import { render, staticRenderFns } from "./InvestorsModuleComponent.vue?vue&type=template&id=07547f34"
import script from "./InvestorsModuleComponent.vue?vue&type=script&lang=js"
export * from "./InvestorsModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./InvestorsModuleComponent.vue?vue&type=style&index=0&id=07547f34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports